import { MutableRefObject, PropsWithChildren } from 'react';
import Button from '~/components/buttons/NewButton';
import IconDocument from '~/icons/icon-document.svg?react';
import { useRenderToPDF } from '~/utils/download';

export interface DownloadPDFProps {
  element: MutableRefObject<HTMLDivElement | null>;
  filename: string;
  onSuccess?: () => void;
}

export const DownloadPDF: React.FC<PropsWithChildren<DownloadPDFProps>> = ({
  children,
  element,
  filename,
  onSuccess,
}) => {
  const renderToPDF = useRenderToPDF();

  const handlePDF = () => {
    if (!element.current) {
      return;
    }
    renderToPDF.mutateAsync(
      { element: element.current, filename },
      {
        onSuccess,
      },
    );
  };

  return (
    <Button loading={renderToPDF.isPending} onClick={handlePDF} Icon={IconDocument}>
      {children}
    </Button>
  );
};
